// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bc-color-primary: #0e1b4d;
  --bc-color-primary2: #fff;
  --bc-color-secondary: #fff;
  --bc-color-secondary2: #fff;
  --bc-font-color: #000;
  --bc-font-color2: #fff;
  --bc-default: #f6f8fa;
  .bc-blur-backdrop {
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
  }
}

/* @tailwind base; */
@tailwind components;
@tailwind utilities;
`, "",{"version":3,"sources":["webpack://./src/main.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB;IACE,mCAAmC;IACnC,2BAA2B;EAC7B;AACF;;AAEA,oBAAoB;AACpB,oBAAoB;AACpB,mBAAmB","sourcesContent":[":root {\n  --bc-color-primary: #0e1b4d;\n  --bc-color-primary2: #fff;\n  --bc-color-secondary: #fff;\n  --bc-color-secondary2: #fff;\n  --bc-font-color: #000;\n  --bc-font-color2: #fff;\n  --bc-default: #f6f8fa;\n  .bc-blur-backdrop {\n    -webkit-backdrop-filter: blur(10px);\n    backdrop-filter: blur(10px);\n  }\n}\n\n/* @tailwind base; */\n@tailwind components;\n@tailwind utilities;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
